import { useCallback } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { eduError } from "@/lib/eduErrors";

export const NOTE_MAX = 300;
export const FORMATS = ["pdf", "docx", "csv", "json"];
export const TRANSFORMS = ["easier", "harder", "roleplay", "debate", "ten_minutes", "pair", "followup", "theme"];

// Human-readable error: offline/timeout → connection message; otherwise the server's explanation.
export const libError = (e, t, fallback) => (!e?.response ? t("lib.network") : eduError(e, t, fallback || t("lib.failed")));

// Toast with a Retry action — only use for safe, non-duplicating operations.
export const retryToast = (msg, t, again) => toast.error(msg, again ? { action: { label: t("lib.retry"), onClick: again } } : undefined);

export function useDownload() {
  const { t } = useI18n();
  const run = useCallback(async (url, filename, body) => {
    try {
      const r = body ? await api.post(url, body, { responseType: "blob" }) : await api.get(url, { responseType: "blob" });
      const href = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = href; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(href), 1000);
    } catch (e) {
      retryToast(!e?.response ? t("lib.network") : t("lib.downloadFailed"), t, () => run(url, filename, body));
    }
  }, [t]);
  return run;
}
